var React = require('react');

function BusinessActivitiesLicenseType (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.2778 21H32.6111M19.2778 29.8889H32.6111M10.3889 21H12.6111M10.3889 29.8889H12.6111M19.2778 12.1111H32.6111M10.3889 12.1111H12.6111M12.6111 1H30.3889C36.5254 1 41.5 5.97461 41.5 12.1111V29.8889C41.5 36.0254 36.5254 41 30.3889 41H12.6111C6.47461 41 1.5 36.0254 1.5 29.8889V12.1111C1.5 5.97461 6.47461 1 12.6111 1Z","stroke":"#CE445B","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

BusinessActivitiesLicenseType.defaultProps = {"width":"43","height":"42","viewBox":"0 0 43 42","fill":"none"};

module.exports = BusinessActivitiesLicenseType;

BusinessActivitiesLicenseType.default = BusinessActivitiesLicenseType;
